import { Message } from 'element-ui';
const DownloadProcessing = (data) => {
  let aLink = document.createElement('a');
  aLink.href = data;
  aLink.style.display = 'none';
  document.body.appendChild(aLink);

  aLink.click();
  document.body.removeChild(aLink);
};
const characterStringPartition = (str, attribute) => {
  let data = str.split(attribute);
  return data;
};
function textcircled(val) {
  if (val) {
    let a = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫'];
    let data = val.replace(/\\textcircled {(1)}/g, a[0]);
    data = data.replace(/\\textcircled {(2)}/g, a[1]);
    data = data.replace(/\\textcircled {(3)}/g, a[2]);
    data = data.replace(/\\textcircled {(4)}/g, a[3]);
    data = data.replace(/\\textcircled {(5)}/g, a[4]);
    data = data.replace(/\\textcircled {(6)}/g, a[5]);
    data = data.replace(/\\textcircled {(7)}/g, a[6]);
    data = data.replace(/\\textcircled {(8)}/g, a[7]);
    data = data.replace(/\\textcircled {(9)}/g, a[8]);
    data = data.replace(/\\textcircled {(10)}/g, a[9]);
    data = data.replace(/\\textcelsius/g, '度');
    data = data.replace(/&amp;nbsp;/g, ' ');
    return data;
  }
}
function Adapter1(canshu, data) {
  canshu.forEach((item) => {
    if (data.some((itemSubId) => item.id == itemSubId.subId)) {
      data.forEach((items) => {
        if (item.childrenList && item.childrenList.length > 0) {
          Adapter1(item.childrenList, data);
        } else if (item.id == items.subId) {
            item.questionOutVo.index = item.questionOutVo.index
              ? item.questionOutVo.index
              : items.queIndex;
            item.right_students = items.rightUserNameList;
            item.wrong_students = items.errorUserNameList;
            item.right_rate = items.passRate * 100;
            item.submit_student_number = items.joinUserNameList.length;
          }
      });
    } else {
      item.questionOutVo.index = item.questionOutVo.index
        ? item.questionOutVo.index
        : '0';
      item.right_students = [];
      item.wrong_students = [];
      item.right_rate = 0;
      item.submit_student_number = 0;
    }
  });
  return canshu;
}
function Adapter3(canshu, data) {
  canshu.forEach((item) => {
    data.forEach((items) => {
      if (item.childrenList && item.childrenList.length > 0) {
        Adapter3(item.childrenList, data);
      } else if (item.id == items.subId) {
          item.right_students = items.rightUserNameList;
          item.wrong_students = items.errorUserNameList;
          item.right_rate = items.passRate * 100 + '%'
          item.submit_rate =
            (items.joinUserNameList.length / items.planUserCount) * 100;
          item.submit_rate = item.submit_rate ? item.submit_rate + '%' : '0.0%';
          item.submit_student_number = items.answerUserCount;
        }
    });
  });
  return canshu;
}

function recombination(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = arr.length - 1; j > i; j--) {
      if (arr[i].serial == arr[j].serial) {
        arr.splice(j, 1);
      }
    }
  }
  return arr;
}
function recombinationCanshu(arr, attribute) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = arr.length - 1; j > i; j--) {
      if (arr[i][attribute] == arr[j][attribute]) {
        arr.splice(j, 1);
      }
    }
  }
  return arr;
}
function recombinationParent(baseTopicInformation) {
  baseTopicInformation.forEach((item) => {
    if (item.childrenList && item.childrenList.length > 0) {
      recombinationParent(item.childrenList);
    } else if (item.answerAreaList.length > 1) {
        item.answerAreaList = recombination(item.answerAreaList);
      }
  });
  return baseTopicInformation;
}

function findParentsId(treeData, id) {
  if (treeData.length == 0) return;
  for (const node of treeData) {
    if (node.id == id) {
      return [];
    } else if (node.children) {
        let res = findParentsId(node.children, id);
        if (res !== undefined) {
          return res.concat(node.id).reverse();
        }
    }
  }
}

export const orgChildIdFindParent = (childId, orgList) => {
  const result = findParentsId(orgList, childId);
  return result || [];
};
function findParentsIds(treeData, id) {
  if (treeData.length == 0) return;
  for (const node of treeData) {
    if (node.id == id) {
      return [];
    } else if (node.childrenList) {
      let res = findParentsIds(node.childrenList, id);
      if (res !== undefined) {
        return res.concat(node.id).reverse();
      }
    }
  }
}

export const orgChildIdFindParents = (childId, orgList) => {
  const result = findParentsIds(orgList, childId);
  return result || [];
};

function searchAnswerArea(item, id) {
  for (const area of item.answerAreaList) {
    if (area.id == id) {
      return [item]
    }
  }
  return undefined
}

function searchChildren(item, id) {
  if (!item.childrenList) return undefined
  const res = IdFindQuestions(id, item.childrenList)
  if (res !== undefined) {
    return res.concat(item).reverse()
  }
  return undefined
}

function IdFindQuestions(id, orglis) {
  if (orglis.length == 0) return
  for (const item of orglis) {
    if (item.answerAreaList && item.answerAreaList.length > 0) {
      const result = searchAnswerArea(item, id)
      if (result !== undefined) return result
    } else {
      const result = searchChildren(item, id)
      if (result !== undefined) return result
    }
  }
}
export const IdFindQuestionFun = (id, orglis) => {
  const result = IdFindQuestions(id, orglis);
  return result || [];
};

function IdFindQuestion(id, orglis) {
  let data = IdFindQuestionFun(id, orglis);
  if (data && data.length > 1) {
    return [data[1]];
  } else {
    return data;
  }
}
function Adapter2(canshu) {
  let dataArry = [];
  canshu.forEach((item) => {
    let data = {
      id: null,
      questionOutVo: {
        index: null,
        featureTypeName: null,
        content: null,
      },
    };
    data.id = item.subId;
    data.questionOutVo.index = item.queIndex;
    data.questionOutVo.content = item.title;
    data.questionOutVo.featureTypeName = item.featureTypeName;
    dataArry.push(data);
  });
  return dataArry;
}
function PropertyReturnObject(arry, attribute, value) {
  let canshu = arry.filter((item, index) => {
    return item[attribute] == value;
  });
  return canshu;
}
function CorrectionResults(baseTopicInformation, CorrectionResultsData) {
  baseTopicInformation.forEach((items) => {
    if (items.childrenList && items.childrenList.length > 0) {
      CorrectionResults(items.childrenList, CorrectionResultsData);
    } else {
      CorrectionResultsData.forEach((CorrectionResultsItem) => {
        if (CorrectionResultsItem.sub_id == items.id) {
          items.answerAreaList.forEach((itemSerial) => {
            if (itemSerial.serialAnswer == CorrectionResultsItem.serial) {
              itemSerial.result =
                CorrectionResultsItem.manual_result === 0 ||
                  CorrectionResultsItem.manual_result
                  ? CorrectionResultsItem.manual_result
                  : CorrectionResultsItem.auto_result;
              itemSerial.correct_score = CorrectionResultsItem.score;
            }
          });
        }
      });
    }
  });
  return baseTopicInformation;
}
const data = {
  baseTopicInformation: null,
  CorrectionResultsItem: [],
};

function CorrectionResultsn(
  baseTopicInformation,
  CorrectionResultsData,
  stutes
) {
  if (!stutes) {
    data.baseTopicInformation = null;
    data.CorrectionResultsItem = [];
  }
  baseTopicInformation.forEach((items) => {
    if (items.childrenList && items.childrenList.length > 0) {
      CorrectionResultsn(items.childrenList, CorrectionResultsData, 'true');
    } else {
      CorrectionResultsData.forEach((CorrectionResultsItem) => {
        if (CorrectionResultsItem.questionId == items.id) {
          items.answerAreaList.forEach((itemSerial) => {
            if (itemSerial.serialAnswer == CorrectionResultsItem.serial) {
              data.CorrectionResultsItem.push(itemSerial);
              itemSerial.result = CorrectionResultsItem.result;
              itemSerial.correct_score = CorrectionResultsItem.score;
            }
          });
        }
      });
    }
  });
  data.baseTopicInformation = baseTopicInformation;
  return data;
}
function handleSpecialCharacters(jsonStr, index) {
  if (
    jsonStr &&
    Object.prototype.toString.call(jsonStr) == '[object String]' &&
    jsonStr != 'null'
  ) {
    jsonStr = jsonStr.replace(/\r/g, '\\r');
    jsonStr = jsonStr.replace(/\n/g, ' ');
    jsonStr = jsonStr.replace(/\t/g, '\\t');
    jsonStr = jsonStr.replace(/\\"/g, '&#34;');
    jsonStr = jsonStr.replace(/\\/g, '\\\\');
    jsonStr = jsonStr.replace(/'/g, '&#39;');
    jsonStr = jsonStr.replace(/</g, '$lt;');
    jsonStr = jsonStr.replace(/>/g, '$gt;');
  }
  return jsonStr;
}

function queryURLParams(url) {
  let result = {};
  let reg1 = /([^?=&#]{1,3000})=([^?=&#]{1,3000})/g;
  let reg2 = /#([^?=&#]{1,3000})/g;
  url.replace(reg1, (n, x, y) => (result[x] = y));
  url.replace(reg2, (n, x) => (result['HASH'] = x));
  return result;
}
function SignIn(response) {
  if (
    response.loginData.data &&
    (response.loginData.data.code == '6666' ||
      response.loginData.data.code == '0001' ||
      response.loginData.data.code == '0002')
  ) {
    localStorage.removeItem(response.token);
    location.reload();
  } else if (response.loginData.data.code == '0000') {
    return response.loginData;
  } else if (response.loginData.data.code) {
      Message({
        message: response.loginData.data.msg,
        type: 'error',
        duration: 5 * 1000,
      });
    } else {
      return response.loginData;
    }
}
export default {
  DownloadProcessing,
  characterStringPartition,
  PropertyReturnObject,
  textcircled,
  Adapter1,
  Adapter2,
  Adapter3,
  orgChildIdFindParent,
  CorrectionResults,
  queryURLParams,
  CorrectionResultsn,
  SignIn,
  recombinationParent,
  orgChildIdFindParents,
  recombination,
  IdFindQuestion,
  IdFindQuestions,
  handleSpecialCharacters,
  recombinationCanshu,
};
